module.exports = {
    BASE_URL: `${process.env.VUE_APP_URL}`,
    // PUB_KEY: `${process.env.PUB_KEY}`,
    LOGIN_KEY: `Z4GjWqydH8poLqG`,
    // CONSOLE_ENV: `${process.env.CONSOLE_ENV}`,
    PHONE_REG:/^[1]([3-9])[0-9]{9}$/,
    MAIL_REG:/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/,
    // ID_REG:/[1-9]\d{5}[1-2]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}(\d|X|x)/
};
